'use client'

import MuxPlayer from '@mux/mux-player-react'
import { useEffect, useState } from 'react'

export type MuxVideoData = {
  video?: {
    asset?: {
      playbackId?: string
      assetId?: string
      filename?: string
    }
  }
  title?: string
  caption?: string
  autoplay?: boolean
  loop?: boolean
  controls?: boolean
}

export default function MuxVideo({
  video,
  title,
  caption,
  autoplay = false,
  loop = false,
  controls = true,
}: MuxVideoData) {
  const [isMounted, setIsMounted] = useState(false)

  // Only render MuxPlayer on client to avoid hydration mismatch
  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!video?.asset?.playbackId) {
    return (
      <div className="flex h-64 items-center justify-center bg-gray-100 text-gray-500">
        <p>Video not available</p>
      </div>
    )
  }

  return (
    <div className="not-prose my-8 w-full">
      <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-black">
        {isMounted ? (
          <MuxPlayer
            playbackId={video.asset.playbackId}
            metadata={{
              video_title: title || 'Video',
            }}
            autoPlay={autoplay ? 'muted' : false}
            loop={loop}
            nohotkeys={!controls}
            className="h-full w-full"
            style={
              {
                aspectRatio: '16/9',
                width: '100%',
                height: '100%',
                '--controls': controls ? undefined : 'none',
              } as React.CSSProperties
            }
          />
        ) : (
          // Loading placeholder to maintain layout
          <div className="flex h-full w-full items-center justify-center bg-gray-900 text-white">
            <div className="flex items-center space-x-2">
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
              <span>Loading video...</span>
            </div>
          </div>
        )}
      </div>

      {caption && <p className="mt-2 text-sm text-gray-600">{caption}</p>}
    </div>
  )
}
